// extracted by mini-css-extract-plugin
module.exports = {"root":"FileInput_root_vZL3R","file":"FileInput_file_2kHoy","input":"FileInput_input_2K4NV"};